export function isFileTypeValid(file: File): boolean {
    switch (file.type) {
    case 'application/xml':
    case 'application/pdf':
    case 'application/msword': // .doc
    case 'application/vnd.openxmlformats-officedocument.wordprocessingml.document': // .docx
    case 'application/vnd.ms-excel': // .xls
    case 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': // .xlsx
    case 'application/vnd.ms-powerpoint': // .ppt
    case 'application/vnd.openxmlformats-officedocument.presentationml.presentation': // .pptx
    case 'application/vnd.oasis.opendocument.text': // .odt
    case 'text/csv':
    case 'text/plain':
    case 'text/xml':
    case 'image/jpeg':
    case 'image/png':
    case 'image/gif':
        return true;
    default:
        return false;
    }
}

export function isFileSizeValue(file: File): boolean {
    // 10 MB
    if (file.size > 0 && file.size < 10240000) {
        return true;
    }

    return false;
}
